/*!

=========================================================
* Paper Kit React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import { Button, Container, Row, Col } from "reactstrap";

// core components

function SectionExamples() {
  return (
    <>
      <div className="section section-dark" style={{marginBottom: "5%"}}>
        <Container>
          <Row className="example-page">
            <h2 className="info-title text-center" style={{marginBottom: "5%"}}>Educational Excellence Across All Ages</h2>
          </Row>
          <Row>
            <Col className="text-center" md="12">
              <a href="/educational-programs">
                <img
                  alt="Educational Programs"
                  className="img-rounded img-responsive"
                  src={require("assets/img/Activities/Heat Airflow.png")}
                  style={{ width: "60%", marginBottom: "20px" }}
                />
              </a>
              <h4>Educational Programs & Training</h4>
              <p>Comprehensive educational solutions for corporate training, IT skills, and child education programs</p>
              <Button
                className="btn-round"
                color="success"
                size="lg"
                href="/educational-programs"
              >
                Explore All Programs
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="section">
        <Container>
          <Row>
            <Col className="text-center" md="6">
              <h2 className="info-title" style={{marginBottom: "10%"}}>Educational Solutions</h2>
              <a href="/educational-solutions">
                <img
                  alt="Educational Solutions"
                  className="img-rounded img-responsive"
                  src={require("assets/img/Teachi.png")}
                  style={{ width: "95%", marginBottom: "2%", height: "60%", objectFit: "cover", objectPosition: "top"}}
                />
              </a>
              <p>AI-powered learning tools and interactive platforms</p>
              <Button
                className="btn-round"
                color="primary"
                href="/educational-solutions"
              >
                Explore Solutions
              </Button>
            </Col>
            <Col className="text-center" md="6">
              <h2 className="info-title" style={{marginBottom: "10%"}}>Knowledge Base</h2>
              <a href="/knowledge-base">
                <img
                  alt="Knowledge Base - CNC Machining"
                  className="img-rounded img-responsive"
                  src={require("assets/img/Activities/CNC Machining.png")}
                  style={{ width: "80%", marginBottom: "2%", height: "60%", objectFit: "cover", objectPosition: "top"}}
                />
              </a>
              <p>Comprehensive guides for equipment, resources, and best practices</p>
              <Button
                className="btn-round"
                color="default"
                href="/knowledge-base"
              >
                Browse Resources
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default SectionExamples;
